/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Evaluates whether the original list constains any, all, or none of the values in this list. `UNSPECIFIED` is supported only in responses. 
*/
export enum ListOperators {
  CONTAINS_ANY_OF_OPERATOR = 'CONTAINS_ANY_OF',
  CONTAINS_NONE_OF_OPERATOR = 'CONTAINS_NONE_OF',
  CONTAINS_ALL_OF_OPERATOR = 'CONTAINS_ALL_OF',
  LIST_OPERATOR_UNSPECIFIED = 'UNSPECIFIED'
}
